module.exports = __webpack_public_path__ + "static/media/left-arrow.f951751b.svg";